import { ApplicationError } from './errors';

export const MAX_KEYWORDS_UTF8_BYTES = 32 * 1024;

export const keywordByteLength = (value: string): number =>
  new Blob([value]).size;

export const displayKeywords = (value: string): string =>
  value.trim() || 'Unnamed';

export const validateKeywords = (value: string): string => {
  const trimmed = value.trim();
  if (keywordByteLength(trimmed) > MAX_KEYWORDS_UTF8_BYTES) {
    throw new ApplicationError(
      'validation',
      'Keywords must be 32 KiB or less.',
    );
  }
  return trimmed;
};
